import { getReferralInfo } from 'lib/api/community';
import useUIConfigStore from 'stores/useUIConfigStore';
import create from 'zustand';

interface State {
  isLoading: boolean;
}

interface Actions {
  fetchCommunityInfo(): Promise<void>;
}

export const useGetReferralInfo = create<State & Actions>((set) => ({
  isLoading: false,

  async fetchCommunityInfo() {
    try {
      // check the value of UI exists
      const remisierUI = useUIConfigStore.getState().getUIValue('remisier');

      if (remisierUI) {
        return;
      }

      // If remisier UI is not exists, then we fetch from API
      set({
        isLoading: true,
      });

      const response = await getReferralInfo();

      if (!response.data) {
        throw new Error('failed to get community info');
      }

      const { data } = response.data;

      useUIConfigStore.getState().setUIValue('remisier', {
        isLeader: data.is_leader,
        isCommunityAccessGranted: data.enabled || data.is_leader,
      });

      set({
        isLoading: false,
      });
    } catch (error) {
      console.error(error);

      set({
        isLoading: false,
      });
    }
  },
}));
